/**
 * Created by mh on 2017/5/24.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Switch, Redirect, Route } from 'react-router-dom';

import NavigationLeftComponent from './NavigationLeft';
import IngestComponent from './Ingest';

import PrivateRoute from '../PrivateRoute.jsx';

// <PrivateRoute exact path={`${match.path}/`} component={IngestComponent} />
// <PrivateRoute exact path={`${match.path}/:page`} component={IngestComponent} />


@inject('auth') @observer
class App extends React.Component {
    render() {
        if (this.props.auth) {
            console.log('Authentication isLoggedIn', this.props.auth.isLoggedIn, this.props.auth.isLoggingIn);
        } else {
            console.log('Authentication not set yet.');
        }
        const { match } = this.props;
        return (
            <div className="row">
                <NavigationLeftComponent />

                <main className="col-sm-9 ml-sm-auto col-md-10 pt-3" role="main">
                    <Switch>
                       <PrivateRoute exact path={`${match.path}/`} component={IngestComponent} />
                       <PrivateRoute exact path={`${match.path}/:page`} component={IngestComponent} />
                       <Route render={() => <Redirect to={`${match.path}/`} />} />
                    </Switch>
                </main>
            </div>
        );
    }
}

// TODO why not wrappedComponent ?
App.propTypes = {
    match: PropTypes.object.isRequired,
};

export default injectIntl(App);
